module.exports = __webpack_public_path__ + "static/media/09-_DSC0173.fc40ccf9.jpg";